import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DynamicComponent, PrivaDynamicComponentSlotComponent } from '@priva/components/dynamic';

import { RootState } from 'app/app.config';
import { selectActiveDialogs } from 'app/state/app.selectors';

@Component({
    selector: 'analytics-dynamic-component-holder',
    templateUrl: './dynamic-component-holder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PrivaDynamicComponentSlotComponent, AsyncPipe],
})
export class DynamicComponentHolderComponent implements OnInit {
    activeDialogs$: Observable<DynamicComponent[]>;

    constructor(private readonly store: Store<RootState>) {}

    ngOnInit() {
        this.activeDialogs$ = this.store.pipe(select(selectActiveDialogs));
    }
}
